import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';

import { NitroText } from 'nitro-components';

import { media } from '../../../../utils/style-utils';
import { getAPIRoot } from '../../../../api/const';
import ButtonIcognito from '../../../../components/common/ButtonIcognito';

const Card = styled(ButtonIcognito)`
  text-align: center;
`;

const CardImage = styled.img`
  height: 70px;
  margin: 0 auto;
  text-align: center;

  ${media.mobileTablet`
    margin: 10px 0;
  `}
`;

const CardDescription = styled.div`
  color: ${props => props.theme.color.primary};
  font-size: ${props => props.theme.size[1]};
  font-weight: bold;
  margin: 30px auto;
`;

const CardDescriptionLabel = styled.span`
  display: inline-block;
  margin-left: 0.5em;
`;

class CardMetricVehicle extends Component {
  onClick = (id, countryCode) => {
    //NOTE: to be updated to url to driver dashboard once its ready - Mythreyi - DONE
    //this.props.onPanelClick(this.props.driverId);

    const dashRoute = `/v1/dashboard/vehicle/${countryCode.toLowerCase()}/${id}`;
    this.context.router.push({
      pathname: dashRoute,
      state: { id, dashboardType: 'vehicle' },
    });
  };

  render() {
    const {
      Description,
      ImageKey,
      MakeModel,
      leaseId,
      countryCode,
    } = this.props;
    return (
      <Card onClick={() => this.onClick(leaseId, countryCode)}>
        <CardImage src={`${getAPIRoot()}${ImageKey}`} alt={`${MakeModel}`} />
        <CardDescription>
          {MakeModel && (
            <CardDescriptionLabel>{MakeModel}</CardDescriptionLabel>
          )}
        </CardDescription>
        <NitroText bold size={4} variant="base3">
          {Description}
        </NitroText>
      </Card>
    );
  }
}

CardMetricVehicle.contextTypes = {
  router: PropTypes.object,
};

CardMetricVehicle.propTypes = {
  Description: PropTypes.string,
  ImageKey: PropTypes.string,
  MakeModel: PropTypes.string,
  leaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CardMetricVehicle;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/CardMetricVehicle.js